import { Contrast } from "../../../types/general.types";
import { MainVariants } from "./constants";
import styled, { css } from "styled-components";
import { hexToRgba } from "@icarros/utils-react";
import { ids } from "@icarros/theme-react";
const { size, color, opacity } = ids || {};
const primary = css `
  background: ${color.action.primary.ids_color_action_primary_base};
  color: ${color.action.primary.ids_color_action_primary_contrast};
  border-color: ${color.action.primary.ids_color_action_primary_variant};
  &:hover,
  &:active {
    background: ${color.action.primary.ids_color_action_primary_variant};
  }
`;
const primaryDisabled = css `
  background: ${color.action.disabled.ids_color_action_disabled_base};
  color: ${color.action.disabled.ids_color_action_disabled_variant};
  cursor: not-allowed;
  border: none;
`;
const primaryOnDark = css `
  background: ${(props) => props.isDisabled
    ? color.contrast.ids_color_contrast_onDark_strong
    : color.contrast.ids_color_contrast_onDark};
  color: ${(props) => props.isDisabled
    ? color.action.disabled.ids_color_action_disabled_variant
    : color.action.primary.ids_color_action_primary_base};
  border: none;
  &:hover,
  &:active {
    background: ${color.contrast.ids_color_contrast_onDark_strong};
  }
`;
const secondary = css `
  background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_contrast, opacity.ids_opacity_empty)};
  border-color: ${color.action.secondary.ids_color_action_secondary_base};
  color: ${color.action.secondary.ids_color_action_secondary_base};
  &:hover,
  &:active {
    border-color: ${color.action.secondary.ids_color_action_secondary_variant};
    color: ${color.action.secondary.ids_color_action_secondary_variant};
    background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_base, opacity.ids_opacity_soft)};
  }
`;
const secondaryOnDark = css `
  background: transparent;
  border-color: ${color.action.secondary.ids_color_action_secondary_contrast};
  color: ${color.action.secondary.ids_color_action_secondary_contrast};
  &:hover,
  &:active {
    background: ${color.action.secondary.ids_color_action_secondary_base_soft};
  }
`;
const secondaryOnLight = css `
  background: ${hexToRgba(color.action.secondary.ids_color_action_secondary_contrast, opacity.ids_opacity_empty)};
  border-color: ${color.contrast.ids_color_contrast_onLight};
  &:hover,
  &:active {
    background: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_soft)};
    border-color: ${hexToRgba(color.contrast.ids_color_contrast_onLight, opacity.ids_opacity_soft)};
  }
`;
const secondaryDisabled = css `
  border-color: ${color.action.disabled.ids_color_action_disabled_base};
  color: ${color.action.disabled.ids_color_action_disabled_variant};
  cursor: not-allowed;
`;
const getButtonKindStyle = (variant, isDisabled, contrast) => {
    switch (variant) {
        case MainVariants.primary: {
            if (isDisabled)
                return primaryDisabled;
            if (contrast === Contrast.dark)
                return primaryOnDark;
            if (contrast === Contrast.light)
                return secondaryOnLight;
            return primary;
        }
        case MainVariants.secondary:
            if (isDisabled)
                return secondaryDisabled;
            if (contrast === Contrast.dark)
                return secondaryOnDark;
            if (contrast === Contrast.light)
                return secondaryOnLight;
            return secondary;
        default:
            return primary;
    }
};
const getButtonSizeStyle = (fillContainer = false, isMobile = false) => {
    if (fillContainer) {
        return css `
      width: 100%;
    `;
    }
};
const getButtonPaddingStyle = (padding) => {
    switch (padding) {
        case "default":
            return "24px";
        case "xsmall":
            return "12px";
        case "small":
            return "16px";
    }
};
export const StyledLoading = styled.div `
  span {
    opacity: 0;
  }
  > div {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
  }
`;
export const StyledButton = styled.button `
  display: flex;
  position: relative;
  justify-content: ${({ justifyBetween }) => justifyBetween ? "space-between" : "center"};
  align-items: center;
  gap: 8px;
  padding: 0px ${({ paddingSize }) => getButtonPaddingStyle(paddingSize)};
  overflow: hidden;
  height: ${size.general.ids_size_general_48x};
  ${({ fillContainer, isMobile }) => getButtonSizeStyle(fillContainer, isMobile)}
  cursor: pointer;
  border-radius: ${ids.size.corner_radius.ids_size_cornerRadius_button};
  border-width: 1px;
  min-width: 180px;
  border-style: solid;
  ${({ variant, isDisabled, contrast }) => getButtonKindStyle(variant, isDisabled, contrast)}
  > span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;
export default StyledButton;
//# sourceMappingURL=Main.style.js.map